<template>
    <div class="d-flex flex-column fill-height profiles-management" id="p_branch_details">
        <v-row>
            <v-col cols="12" class="d-flex">
                <div ref="detailsContainer" style="width: 100%; display: flex; box-shadow: none">
                    <app-card :contentStyle="'padding: 8px; overflow: inherit;'" contentIsScrollable="false">
                        <template v-slot:title>
                            <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1"> {{ tb('Gestão de Perfis') }} </v-card-title>
                        </template>

                        <template v-slot:content>
                            <v-row class="d-flex flex-column px-2 mx-1 my-0 wrap-content">
                                <v-col cols="12" md="12" sm="12" class="d-flex justify-start px-0 pt-0">
                                    <v-tabs centered id="myprovet-tabs" v-model="selectedTabIndex" class="pt-1 ml-n1" style="border-radius: 8px" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px" start show-arrows>
                                        <v-tabs-slider color="#154579"></v-tabs-slider>

                                        <v-tab class="myprovet-tab-item" v-for="item in tabItems" :key="item.tab">
                                            {{ tb(item.tab) }}
                                        </v-tab>
                                    </v-tabs>
                                </v-col>

                                <v-divider></v-divider>

                                <!-- Dados Perfis -->
                                <div class="client-tab" ref="detailsTab" v-if="selectedTabIndex === getSelectedTabIndex('Perfis')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col class="pr-0" style="max-width: fit-content">
                                            <div>
                                                <div class="title-text dark-blue-color" style="max-width: min-content; white-space: nowrap">{{ tb('Lista de Perfis') }}</div>
                                            </div>
                                        </v-col>
                                        <v-col class="pl-0">
                                            <div>

                                                <v-btn text outlined class="myprovet-btn-ok v-btn v-btn--text theme--light v-size--default text-none px8 mr-2" @click="openNewProfileUser" data-cy="app-dialog-submit-btn"> {{ tb('NOVO PERFIL') }}</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex align-center justify-space-between mx-0 mt-0">
                                        <v-col cols="12" class="d-flex mx-0 mt-0 pt-0">
                                            <v-col cols="4" >
                                            <v-text-field
                                                        v-model="searchProfile"
                                                        append-icon="mdi-magnify"
                                                        :label="tb('Procurar Perfil')"
                                                        single-line
                                                        hide-details
                                                    ></v-text-field>
                                            </v-col>
                                            <v-col cols="8">
                                            </v-col>
                                        </v-col>

                                    </v-row>

                                    <div class="px-3">
                                        <v-data-table id="delivery_table"

                                            ref="datatableProfilesDetails"
                                            class="elevation-1 mt-2 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                            fixed-header
                                            multi-sort
                                            :headers="tHeaders(profiles_headers)"
                                            :header-props="headerProps"
                                            :hide-default-headers="isMobile"
                                            :items="profiles"
                                            :search="searchProfile"
                                            :footer-props="footerPropsCustoms"
                                            :no-data-text="tb('Não existem perfis para mostrar.')"
                                            no-results-text="Não existem perfis para mostrar."
                                            :loading="isMobile?isLoading:false"
                                            :loading-text="$t('table.loading')"
                                        >
                                            <template #item.name="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.name }}
                                                </div>
                                            </template>

                                            <template #item.created_by="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.created_by }}
                                                </div>
                                            </template>

                                            <template #item.created_at="scope">
                                                <div class="datatable-designation-text">
                                                    {{ formatDate(scope.item.created_at) }}
                                                </div>
                                            </template>

                                            <template #[`item.actions`]="scope">
                                               <!-- <div v-if="userStore.hasPermissionTo('Request client details page changes')" class="d-flex justify-end align-center">-->
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openProfileChangeDialog(scope.item)"> mdi-square-edit-outline </v-icon>
                                                        </template>
                                                        <span>{{ tb('Alterar Perfil') }}</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openCloneProfileChangeDialog(scope.item)">  mdi-content-copy </v-icon>
                                                        </template>
                                                        <span>{{ tb('Copiar Perfil') }}</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openRemove(scope.item)"> mdi-delete </v-icon>
                                                        </template>
                                                        <span>{{ tb('Remover Perfil') }}</span>
                                                    </v-tooltip>
                                               <!-- </div>-->
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>

                                <!-- Dados Utilizadores -->
                                <div class="client-tab" ref="detailsTab" v-if="selectedTabIndex === getSelectedTabIndex('Utilizadores')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col cols="8">
                                            <div>
                                                <div class="title-text dark-blue-color">{{ tb('Lista de Utilizadores') }}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="4" style="right: 0px">
                                            <v-row class="d-flex align-center justify-space-between mx-0 mt-0">
                                            <v-col cols="12">
                                                <v-text-field
                                                            v-model="searchUser"
                                                            append-icon="mdi-magnify"
                                                            :label="tb('Procurar Utilizador')"
                                                            single-line
                                                            hide-details
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                        </v-col>
                                    </v-row>
                                    <div class="px-3">
                                        <v-data-table id="profile_users"
                                            ref="datatableProfilesUsersDetails"
                                            class="elevation-1 mt-2 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                            fixed-header
                                            multi-sort
                                            :headers="tHeaders(profiles_users_headers)"
                                            :header-props="headerProps"
                                            :hide-default-headers="isMobile"
                                            :items="usersProfiles"
                                            hide-default-footer
                                            :search="searchUser"
                                            :no-data-text="tb('Não existem utilizadores para mostrar.')"
                                            no-results-text="Não existem utilizadores para mostrar."
                                            :loading="isMobile?isLoading:false"
                                            :loading-text="$t('table.loading')"
                                        >
                                            <template #item.name="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.name }}
                                                </div>
                                            </template>

                                            <template #item.email="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.email }}
                                                </div>
                                            </template>

                                            <template #item.profiles="scope">
                                                <div class="datatable-designation-text">
                                                    <!--<div v-html="getProfileNames(scope.item.profiles)">

                                                    </div>-->
                                                    <div v-if="scope.item.profiles_list.length >0">
                                                            <v-select :disabled="true"
                                                            v-model="scope.item.profiles_list"
                                                            :items="scope.item.profiles_list"
                                                            filled
                                                            chips
                                                            solo
                                                            multiple
                                                        ></v-select>
                                                    </div>
                                                </div>
                                            </template>
                                            <template #[`item.actions`]="scope">
                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openProfileUserChangeDialog(scope.item)"> mdi-square-edit-outline </v-icon>
                                                        </template>
                                                        <span>{{ tb('Editar Utilizador') }}</span>
                                                    </v-tooltip>
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>
                            </v-row>
                        </template>
                    </app-card>
                </div>
            </v-col>
        </v-row>

       <!-- <edit-accept-pending-products-dialog :value="isEditAcceptPendingDialogOpen" :accepts-pending-products="getAcceptPendingProducts" @on-success="isEditAcceptPendingDialogOpen = false" @on-cancel="isEditAcceptPendingDialogOpen = false"></edit-accept-pending-products-dialog>
-->
        <profile-dialog :isMobile="isMobile"
            @on-cancel="isProfileEditDialogOpen = false"
            v-if="isProfileEditDialogOpen"
            :value="isProfileEditDialogOpen"
            :originalProfile="currentProfile"
            :branchId="getBranchId"
            :title="tb(title)"
            @on-success="isProfileEditDialogOpen = false"
        ></profile-dialog>

        <profile-user-dialog :isMobile="isMobile"
            @on-cancel="isProfileUserEditDialogOpen = false"
            v-if="isProfileUserEditDialogOpen"
            :value="isProfileUserEditDialogOpen"
            :originalUser="currentProfileUser"
            :branchId="getBranchId"
            :profilesList="profiles"
            @on-success="isProfileUserEditDialogOpen = false"
        ></profile-user-dialog>

        <app-dialog :value="isConfirmChangesDialogOpen" @input="isConfirmChangesDialogOpen = $event" :title="tb('Atenção!')" width="35vw">
            <template v-slot:content>
                <p class="dark-blue-color pt-4" style="font-size: 16px">{{ tb('Tem a certeza que deseja eliminar o registo?') }}</p>
            </template>

            <template v-slot:buttons>
                <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isConfirmChangesDialogOpen = false">{{ tb('Cancelar') }}</v-btn>
                <v-btn text class="myprovet-btn-ok px-8" @click="removeItemFromList">{{ tb('Confirmar') }}</v-btn>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';
import { useAppStore } from '@/Stores/app';
import MainLayout from './../../Layouts/MainLayout';
import { axios } from '@/Services/Backend';
import ResizeObserver from 'resize-observer-polyfill';
import { clone } from 'lodash';

export default {
    layout: MainLayout,

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        profiles_headers: [Object, Array],
        profiles_users_headers:[Object, Array],
        link360: String,
        pending_explanation_message: String,
    },

    data: () => ({
        profiles:[],
        usersProfiles:[],
        searchProfile:'',
        searchUser:'',
        currentProfile:null,
        isProfileEditDialogOpen:false,
        currentProfileUser:null,
        isProfileUserEditDialogOpen:false,
        isLoading: false,
        datatableSize: 200,
        resizeObserver: null,
        generalDataSize: 200,
        selectedTabIndex: 0,
        title:null,
        unknownValue: ' ', // Keeps the field name above the field while viewing the data
        editingGeneralData: false,
        editedGeneralData: {},
        selectedAddress: null,
        isConfirmChangesDialogOpen: false,
        tabItems: [],
        default_profile: {
                id:null,
                name: null,
                client_number:null,
                profile_excluded_products:[],
                profile_excluded_labs:[],
        },
        default_profile_user: {
                id:null,
                name: null,
                email:null,
                profiles:[],
        },
        footerPropsCustoms:{
                'items-per-page-options':[10,20,50 /*,{ text: "Todos", value: -1 }*/],
                'items-per-page-text': i18n.t('table.itemsPerPage')
            },

    }),

    computed: {
        ...mapStores(useBranchStore, useUserStore,useAppStore),

        // Branch
        getBranchId() {
            return this.branchStore.branch?.id ?? this.unknownValue;
        },

        getBranchClientNumber() {
            return this.branchStore.branch?.client_number ?? this.unknownValue;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    watch: {
        'userStore.user': {
            handler: function (user) {
                if (!user) return;
                this.setTabItems();
            },
            immediate: true,
        },
    },
    created(){

    },
    mounted() {
        this.prepareResponsiveBehaviour();
        setTimeout(()=>{
            this.getDataPerfis()
        },500)
        window.EventBus.$on('update:profiles-list', (e) => {
            this.getDataPerfis(e)
        })

    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.detailsTab);
        window.EventBus.$off('update:profiles-list',null);
    },

    methods: {
        getProfileNames(profiles){
            let str=''
            _.each(profiles,(o,i)=>{
                let rs= _.find(this.profiles,{id:o.profile_id})
                 if(rs && i>0){
                    str=str+', '+rs.name
                 }else{
                    str=rs.name
                 }
            })
          return str
        },
        openRemove(item){
            this.isConfirmChangesDialogOpen=true,
            this.currentItem=_.clone(item)
        },
        removeItemFromList(){
            this.isConfirmChangesDialogOpen=false
            if(this.selectedTabIndex==0){
                let index = _.findIndex(this.profiles,{id:this.currentItem.id})
                if(index!=-1){
                    //this.currentProfile.profile_excluded_products.splice(index,1)
                    this.remove(this.currentItem.id)
                    //this.showSuccess('O item selecionado foi removido com sucesso!');
                    this.currentItem=null
                }
            }else{
                let index = _.findIndex(this.currentProfile.profile_excluded_labs,{laboratory_code:this.currentItem.laboratory_code})
                if(index!=-1){
                    this.remove(this.currentItem.id)
                    //this.showSuccess('O item selecionado foi removido com sucesso!');
                    this.currentItem=null
                }
            }
        },
        remove(id) {

            if(id){
                axios.delete('/api/profiles/profile/'+id).then((data) => {
                        this.showSuccess(this.tb('O perfil foi eliminado com sucesso!'));
                        this.$emit('on-success', true);
                        this.getDataPerfis()
                }).catch((data) => {
                        this.showError(this.tb('Ocorreu um erro ao eliminar o perfil. Por favor tente novamente.'));
                        this.loading = false;
                });
            }
        },
        getDataPerfis() {
            this.$nextTick(_=>{
                this.isLoading = true;
            })
            //console.log(this.useBranchStore,this.branchStore,_.clone(this.branchStore),_.clone(this.useUserStore));
            //let branch=this.useBranchStore.id
            let data={
               client_number:this.branchStore.branch.client_number
            }
            //console.log('data',data);
            axios
                .post('/api/profiles/list', data)
                .then((response) => {
                    this.usersProfiles=response.data.users
                    this.profiles=response.data.profiles
                    //this.showSuccess('O seu pedido de alterações foi enviado com sucesso!');
                    this.editingGeneralData = false;
                    this.isConfirmChangesDialogOpen = false;
                })
                .catch(() => {
                    //this.showError('O envio do seu pedido de alterações falhou. Tente novamente mais tarde ou contacte diretamente a Propec.');
                    this.isLoading = false;
                });
        },
        openNewProfileUser(){

            let clone=_.clone(this.default_profile);
            clone.client_number = this.getBranchId;
            this.currentProfile = clone;
            this.title='NOVO PERFIL'
            this.isProfileEditDialogOpen = true;
            //console.log('openNewProfileUser',this.currentProfile);
        },
        openProfileChangeDialog(item) {
            let clone=_.clone(this.default_profile);
            _.assign(clone,item)
            this.currentProfile=clone
            this.title='EDITAR PERFIL'
            this.isProfileEditDialogOpen = true;
            //console.log('item',item,this.currentProfile);
        },
        openCloneProfileChangeDialog(item){
            let clone=_.clone(this.default_profile);
            _.assign(clone,item)
            clone.name=clone.name +' (NOVO)'
            clone.id=null
            _.each(clone.profile_excluded_products,(prod)=>{
                  prod.id = null
                  prod.profile_id = null
            })
            _.each(clone.profile_excluded_labs,(lab)=>{
                  lab.id = null
                  lab.profile_id = null
            })
            this.currentProfile=clone
            this.title='NOVO PERFIL'
            this.isProfileEditDialogOpen = true;
        },
        openProfileUserChangeDialog(item){
            let clone=_.clone(this.default_profile_user);
            _.assign(clone,item)
            this.currentProfileUser = clone;
            //this.title='NOVO PERFIL'
            this.isProfileUserEditDialogOpen = true;
        },
        /*
        startGeneralDataChanges() {
            this.copyOriginalData();
            this.editingGeneralData = true;
        },*/

        cancelGeneralDataChanges() {
            this.editingGeneralData = false;
        },
        prepareResponsiveBehaviour() {
            // Table and General Data responsivity
            const makeResponsive = () => {
                this.$nextTick(() => {
                    this.computeDatatableSize();
                });
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);

            window.addEventListener('resize', makeResponsive);

            // Scroll arrow
            this.$nextTick(() => {
                this.resizeObserver.observe(this.$refs.detailsTab);
            });
        },

        computeDatatableSize() {
            this.datatableSize = window.innerHeight - 395;
            this.generalDataSize = this.editingGeneralData ? window.innerHeight - 348 : window.innerHeight - 340;
        },

        setTabItems() {
            let tabs = [];

            tabs.push({ tab: 'Perfis' });
            tabs.push({ tab: 'Utilizadores' });
            this.tabItems = tabs;
        },

        getSelectedTabIndex(tab) {
            if (this.tabItems.length === 0) return 0;

            return this.tabItems.findIndex((obj) => {
                return obj.tab === tab;
            });
        },
    },
};
</script>



<style scoped>
.client-tab {
    padding-top: 12px;
}

.rotate-360-svg {
    margin-top: -4px;
    filter: invert(22%) sepia(20%) saturate(4200%) hue-rotate(187deg) brightness(89%) contrast(92%);
}


</style>

